import { render } from "./trend-data.vue?vue&type=template&id=142ff775&scoped=true&ts=true"
import script from "./trend-data.vue?vue&type=script&lang=ts"
export * from "./trend-data.vue?vue&type=script&lang=ts"

import "./trend-data.vue?vue&type=style&index=0&id=142ff775&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142ff775"]])

export default __exports__